/* Packages */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/* Helpers */
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { 
  getParameterFromUrl,
  flushUrlFromParameters,
  getPixelData,
  returnToOrigin,
  getIfSpeedAppEnabled 
} from '../../../helpers/utils';
import { addItemToLS, deleteItemFromLS } from '../../../helpers/localStorage';
import { addItemToSS, getItemFromSS } from '../../../helpers/sessionStorage';
import { simulationOneMinute } from '../../../helpers/mocks/simulation';
import { initialSliderOneMinute } from '../../../helpers/mocks/sliders';
import { initFirstSimulation } from '../../../helpers/handleCurrentSimulationData';

/* Mocks */
import { mockTableOneMinute } from '../../../helpers/mocks/tables';

/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import {
  setAmountSliderThunk,
  setPaymentSliderThunk,
  setTableThunk,
  setTokenThunk,
  setModalThunk,
  setCurrentSimulationThunk,
  setSkipSimulationThunk,
  setIsSpeedAppThunk
} from '../../../redux/actions/index';

/* Components */
import { Header } from '../../shared/Header';
import { Overlay } from '../../shared/Overlay';
import { Modal } from '../../shared/Modal';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { PageHeading } from '../../shared/PageHeading';
import { LoanCategorySelector } from '../../shared/LoanCategorySelector';
import { Slider } from '../../shared/Slider';
import { RequestInfo } from '../../shared/RequestInfo';
import { BizmaticaHiddenForm } from '../../shared/BizmaticaHiddenForm';
import { SimulationButton } from '../../shared/SimulationButton';
import { Button } from '../../shared/Button';
import { RetrieveEstimateLink } from '../../shared/RetrieveEstimateLink';
import { Footer } from '../../shared/Footer';
import { ScrollArrows } from '../../shared/ScrollArrows';

export const SimulatoreUnMinuto = (props) => {
  const history = useHistory();
  const initMockSimulation = history?.location?.state?.returnButtonClicked || false;
  const table = useSelector(state => state.table.complete);
  const dispatch = useDispatch();
  const setTable = (tableData) => dispatch(setTableThunk(tableData));
  const setToken = (token) => dispatch(setTokenThunk(token));
  const setModal = (modal, options) => dispatch(setModalThunk(modal, options));
  const setSkipSimulation = (skipSimulation) => dispatch(setSkipSimulationThunk(skipSimulation));
  const setCurrentSimulation = (currentSimulationData) => dispatch(setCurrentSimulationThunk(currentSimulationData));
  const setAmountSlider = (amountOptions) => dispatch(setAmountSliderThunk(amountOptions));
  const setPaymentSlider = (paymentOptions) => dispatch(setPaymentSliderThunk(paymentOptions));
  const setIsSpeedApp = (isSpeedApp) => dispatch(setIsSpeedAppThunk(isSpeedApp));
  const [skipRecap, setSkipRecap] = useState(false);

  useEffect(function() {
    /*
    let token = getParameterFromUrl("token");
    const ds = getParameterFromUrl("ds");
    const bizmaticaEndpointEnvironment = getParameterFromUrl("formaction");
    const skipRecap = getParameterFromUrl("SC_RICALCOLO");
    const skipSimulation = getParameterFromUrl("skipSimulation");
    */
    const isSpeedApp = getParameterFromUrl("SpeedApp") || false;

    setIsSpeedApp(getIfSpeedAppEnabled(isSpeedApp));

    deleteItemFromLS('token');

    //If turning back form recap doesn't do these actions;
    if(!initMockSimulation) {
      setCurrentSimulation({...simulationOneMinute});
      setAmountSlider({...initialSliderOneMinute.amount});
      setPaymentSlider({...initialSliderOneMinute.payment});
    }

    let fullUrl = getParameterFromUrl("url");

    //Fallback for turning back from recap;
    if(!fullUrl) {
      fullUrl = getItemFromSS("redirectUrl");
    }
    
    if(
      fullUrl
      && fullUrl !== ''
      && fullUrl.length > 0
      //&& fullUrl.indexOf('token') !== -1
    ) {
      let redirectToken = '';

      if(fullUrl.indexOf('token=') !== -1) {
        //Management with encoded url
        redirectToken = getParameterFromUrl("token", `?${fullUrl.split('?')[1]}`);
      } else {
        //Management with clear url
        const tokenStrPos = fullUrl.indexOf('?token');
        if(tokenStrPos >= 0) {
          fullUrl = fullUrl.substring(0, tokenStrPos);
          redirectToken = getParameterFromUrl("token");
        } else if(getItemFromSS("redirectToken")) {
          //Fallback for turning back from recap;
          redirectToken = getItemFromSS("redirectToken");
        }
      }
      
      addItemToSS("redirectUrl", decodeURIComponent(fullUrl));
      
      if(
        redirectToken
        && redirectToken !== ''
      ) {
        addItemToSS("redirectToken", redirectToken);
      } else {
        returnToOrigin(window.location.origin);
      }

      //Flushing url from parameter passed;
      flushUrlFromParameters();
    } else {
      returnToOrigin(window.location.origin);
    }


    /*
    if (token) {
      addItemToLS('token', token);
    } else {
      token = getItemFromLS('token');
    }

    setToken(token);
    */
    
    /*
    if (ds) {
      const simulatorIsDown = ds === "no" ? true : false;
      sessionStorage.setItem("simulatorIsDown", simulatorIsDown);
    }
    */
    
    /*
    if (bizmaticaEndpointEnvironment) {
      sessionStorage.setItem("bizmaticaEndpointEnvironment", bizmaticaEndpointEnvironment);
    }
    */

    /*
    if (skipRecap === "S") {
      setSkipRecap(true);
      sessionStorage.setItem("skipRecap", true);
    } else {
      sessionStorage.setItem("skipRecap", false);
    }

    if (skipSimulation === "true") {
      var outerSimulation = JSON.parse(sessionStorage.getItem('outerSimulation'));
      
      if (outerSimulation && !objectIsEmpty(outerSimulation)) {
        const { purpose, amount, payment, numberOfInstallments, TAN, TAEG, others } = outerSimulation;

        setSkipSimulation(true);

        setCurrentSimulation({
          purpose: {
            index: purpose.index,
            icon: purpose.icon,
            text: purpose.text,
            code: purpose.code,
          },
          amount: {
            current: amount.current,
            min: amount.min,
            max: amount.max,
          },
          payment: {
            current: payment.current,
            min: payment.min,
            max: payment.max,
          },
          numberOfInstallments: {
            min: numberOfInstallments.min,
            max: numberOfInstallments.max,
          },
          TAN: {
            min: TAN.min,
            max: TAN.max,
          },
          TAEG: {
            min: TAEG.min,
            max: TAEG.max,
          },
          others: {
            transparencyDuty: others.transparencyDuty,
            administrationFees: others.administrationFees,
            stampDuty: others.stampDuty,
          }
        });

        history.push('/risultato-profilo-web.html');
      }
    }
    */
  }, []);

  useEffect(function() {
    getPixelData('/simulatore-commerciale-1-minuto.html');
    addItemToLS('homePage', '/simulatore-commerciale-1-minuto.html');

    const fallbackCallbacks = {
      200: function(response) {
        const table = response.data;

        if (Array.isArray(table) && table.length) {
          setTable(table);
          initFirstSimulation(
            { 
              table, 
              logarithmicCurrentAmount: simulationOneMinute.amount.value,
              //skipSimulation: getParameterFromUrl("skipSimulation") === 'true'
            }, 
            {
              setCurrentSimulation,
              setPaymentSlider
            },
            !initMockSimulation
          );
        } else {
          console.warn("Table is an empty array");
        }
      },
      400: function() {},
      404: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableOneMinute);
        }
      },
      500: function() {},
      default: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableOneMinute);
        }
      },
    };

    const callbacks = {
      200: function(response) {
        const table = response.data;

        if (Array.isArray(table) && table.length) {
          setTable(table);
          initFirstSimulation(
            { 
              table, 
              logarithmicCurrentAmount: simulationOneMinute.amount.value,
              //skipSimulation: getParameterFromUrl("skipSimulation") === 'true'
            }, 
            {
              setCurrentSimulation,
              setPaymentSlider
            },
            !initMockSimulation
          );
        } else {
          console.warn("Table is an empty array");
        }
      },
      400: function() {},
      403: function() {
        // Fallback
        handleAPIRequest({
          method: 'GET',
          url: getPartnerEndpoints("compass").api.tableFallback,
        }, fallbackCallbacks);
      },
      404: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableOneMinute);
        }
      },
      500: function() {},
      default: function() {},
    };
    
    handleAPIRequest({
      method: 'GET',
      url: getPartnerEndpoints("compass").api.tableOneMinute,
    }, callbacks);
  }, []);

  //Flushing history.state after using it;
  useEffect(function () {
    history.replace({ state: undefined });
  }, []);

  return (
    <div className="wrapper">
      <Overlay
        modalTarget="moreInfo"
        clickEvent={
          function() {
            setModal('moreInfo', {
              isVisible: false,
            })
          }
        }
      >
        <Modal
          content={
            {
              text: ["I valori dei tassi (TAN e TAEG) rimarranno espressi come intervallo tra minimo e massimo, finchè non avremo preso in carico e valutato la tua richiesta.", <br key="1" />, "Per personalizzare la tua richiesta di prestito ti chiediamo quindi di fornirci maggiori informazioni."]
            }
          }
          button={
            {
              text: "Ok, ho capito",
              clickEvent: function() {
                setModal('moreInfo', {
                  isVisible: false,
                })
              },
            }
          }
        />
      </Overlay>
      <Header
        logo={
          { 
            image: './images/logo_compass.png',
            alt: 'Logo compass',
            redirect: '/simulatore/simulatore-commerciale-1-minuto.html',
          }
        }
        isSimulator={true}
      />
      <MainContentWrapper isSimulator={true}>
        <PageHeading title="Simulatore risposta in 1 minuto" isSimulator={true}/>
        <LoanCategorySelector title="Qual è l'obiettivo del prestito?"/>
        <Slider table={table} type="amount" title="Che importo ti serve?" />
        <Slider table={table} type="payment" title="Che rata mensile vuoi pagare?" />
        <RequestInfo skipRecap={skipRecap} />
        { 
          skipRecap ? 
            <BizmaticaHiddenForm returnUrl={window.location.href}>
              <SimulationButton />
            </BizmaticaHiddenForm> 
          :
            <Button 
              isSimulator={true}
              color="red"
              text="Calcola"
              clickEvent={function() { 
                history.push(
                  '/risultato-profilo-web.html',
                  { returnPage: 'simulatore-commerciale-1-minuto.html' }
                );
              }}
            />
        }
        <RetrieveEstimateLink />
      </MainContentWrapper>
      <Footer theme="compass-1-minuto" isSimulator={true} />
      <ScrollArrows isSimulator={true} />
    </div>
  );
}

export default SimulatoreUnMinuto;
